import * as React from 'react';
import Helmet from 'react-helmet';

import { helmet } from 'utils/helmet';
import { NavContainer as Nav } from 'containers/nav-container/NavContainer';
import { SearchContainer as Search } from 'containers/search/SearchContainer';
import { FooterContainer } from 'containers/footer-container/FooterContainer';
import { Devtools } from 'components/devtools/Devtools';

// stop re-render on update
import { LocationWrapper } from 'components/location-wrapper/LocationWrapper';

import s from './AppLayout.scss';
import { PageTransition } from 'components/page-transition/PageTransition';
import { Consent } from 'components/consent/Consent';

interface IAppLayoutProps {
  children: React.ReactNode;
  location: {
    pathname: string;
  };
}

const isDev = process.env.NODE_ENV === 'development';

export default ({ children, location }: IAppLayoutProps) => {
  return (
    <div className={s.layout}>
      <Helmet {...helmet} />
      <Nav />
      <PageTransition location={location}>

        <LocationWrapper pathname={location.pathname}>
          

          <main className={s.layout__content}>{children}</main>

          <FooterContainer />
          {/* TODO intl */}
          <Consent>
            We use cookies to ensure that we give you the best experience on our website. If you
            continue without changing your browser settings, we will assume that you are happy to
            receive them.
          </Consent>
        </LocationWrapper>
      </PageTransition>
      <Search />

      {isDev && <Devtools />}
    </div>
  );
};
